<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ctp" id="p0024-01-0"><a id="page18"></a><a href="#/contents#fn_17" id="sn_17">DAY 17</a></p>
<p class="ct"><a href="#/contents#fn_17">LORD, DID I HEAR YOU RIGHT?</a></p>
<p class="ext"><span><i>God said to Noah, “I am going to put an end to all people. So make yourself an ark. You will enter the ark—you and your sons and your wife and your sons’ wives with you. You are to bring into the ark two of all living creatures, male and female, to keep them alive with you.”</i></span></p>
<p class="txr"><span><span class="small">GENESIS</span> 6:3–14, 18–19</span></p>
<p class="tx1" id="p0024-04-4"><span class="dcap">T</span>hree hundred cubits long, fifty cubits wide, and thirty cubits high. Think football fields. One and a half football fields long and three-quarters of a football field wide, to be precise. And think, regarding its height, at least a four-story building. Yes, the ark God commanded Noah to build for the coming rainstorm was huge.</p>
<p class="tx">And what would the neighbors have thought about Noah’s project? “Rain? Water falling from the sky? Next you’ll be trying to convince us that some band of red, orange, yellow, green, blue, and purple will be arcing across the sky!”</p>
<p class="tx">There was nothing easy about Noah’s assignment. And there may have been nothing appealing about having “two of all living creatures” as shipmates. But—looking for a positive in this—jellyfish, sharks, piranhas, alligators, and anacondas did not need a place on the boat! They’d do just fine with the precipitation! We may not feel equipped for the task, but God provides.</p>
<p class="tx2">WHEN GOD CALLS, HE ENABLES.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter20.vue?1c104e7c